import React, {useState} from "react";
import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";
import Button from "@mui/material/Button";
import ArrowForwardIcon from "@mui/icons-material/ArrowForward";
import {useNavigate} from "react-router";
import {AccessibleAudioPlayer} from "../app/AccessibleAudioPlayer";
import {MEDITATION_TRACKS, DEFAULT_TRACK} from "../meditation/meditationTracks";
import {MeditationTrackSelector} from "../meditation/MeditationTrackSelector";
import {BreathingOrb} from "../three/BreathingOrb";

export const MeditationSection = () => {
    const navigate = useNavigate();
    const [selectedTrack, setSelectedTrack] = useState(DEFAULT_TRACK);

    return (
        <Box
            component="section"
            id="meditasjon"
            aria-labelledby="meditation-title"
            sx={{
                py: {xs: 4, md: 6},
                width: "100%",
                maxWidth: "100%",
            }}
        >
            <Box sx={{textAlign: "center", mb: 3.5, maxWidth: 760, mx: "auto"}}>
                <Typography
                    id="meditation-title"
                    variant="h4"
                    component="h2"
                    sx={{
                        fontWeight: 800,
                        fontSize: {xs: "1.6rem", sm: "2rem", md: "2.25rem"},
                        color: "primary.main",
                        mb: 1.5,
                        letterSpacing: "-0.01em",
                    }}
                >
                    Veiledede meditasjonsøvelser
                </Typography>
                <Typography
                    variant="body1"
                    color="text.secondary"
                    sx={{fontSize: {xs: "0.975rem", sm: "1.05rem"}, lineHeight: 1.7}}
                >
                    Trenger du en pustepause akkurat nå? Følg den beroligende pustekulen, velg ønsket øvelse under og trykk spill av for å oppleve ro og tilstedeværelse i nuet.
                </Typography>
            </Box>

            <Box sx={{maxWidth: 780, mx: "auto"}}>
                {/* Den Resonante Pustekulen (The Calming Breathing Orb) */}
                <Box sx={{display: "flex", justifyContent: "center", mb: 3}}>
                    <BreathingOrb size={170} />
                </Box>

                <MeditationTrackSelector
                    tracks={MEDITATION_TRACKS}
                    selectedTrackId={selectedTrack.id}
                    onSelectTrack={setSelectedTrack}
                />

                <AccessibleAudioPlayer
                    key={selectedTrack.id}
                    src={selectedTrack.src}
                    title={selectedTrack.title}
                    subtitle={selectedTrack.subtitle}
                    transcript={selectedTrack.transcript}
                />
            </Box>

            <Box sx={{mt: 3.5, textAlign: "center"}}>
                <Button
                    variant="outlined"
                    color="primary"
                    endIcon={<ArrowForwardIcon />}
                    onClick={() => navigate("/meditation")}
                    sx={{
                        borderRadius: 3,
                        px: {xs: 2, sm: 3.5},
                        py: 1.25,
                        minHeight: 44,
                        width: {xs: "100%", sm: "auto"},
                        maxWidth: "100%",
                        whiteSpace: {xs: "normal", sm: "nowrap"},
                        fontWeight: 700,
                        textTransform: "none",
                        fontSize: "0.95rem",
                        borderColor: "rgba(40, 82, 56, 0.4)",
                        "&:hover": {
                            borderColor: "primary.main",
                            bgcolor: "rgba(40, 82, 56, 0.05)",
                        },
                        "&:focus-visible": {
                            outline: "2px solid #285238",
                            outlineOffset: 2,
                        },
                    }}
                >
                    Les mer om mindfulness og øvelsene
                </Button>
            </Box>
        </Box>
    );
};
